import { defineMessages } from 'react-intl';

export const estimationExportMessageDefinitions = defineMessages({
  reference: {
    id: 'export.estimation.reference',
    defaultMessage: '#',
  },
  group: {
    id: 'export.estimation.group',
    defaultMessage: 'Group',
  },
  phase: {
    id: 'export.estimation.phase',
    defaultMessage: 'Phase',
  },
  phaseLead: {
    id: 'export.estimation.phaseLead',
    defaultMessage: 'Phase Lead',
  },
  methodology: {
    id: 'export.estimation.methodology',
    defaultMessage: 'Methodology',
  },
  estimate: {
    id: 'export.estimation.estimate',
    defaultMessage: 'Estimate',
  },
  estimateCheck: {
    id: 'export.estimation.estimateCheck',
    defaultMessage: 'Estimate Check',
  },
  costsSum: {
    id: 'export.estimation.costsSum',
    defaultMessage: 'Costs Sum',
  },
  total: {
    id: 'export.estimation.total',
    defaultMessage: 'Total',
  },
  assumptions: {
    id: 'export.estimation.assumptions',
    defaultMessage: 'Assumptions',
  },
  masterdata: {
    id: 'export.estimation.masterdata',
    defaultMessage: 'Masterdata',
  },
});
